export enum Holiday {
  Easter = 'Easter',
  Christmas = 'Christmas',
}
